import { useRef, useState } from 'react';
// import { Title } from "../../components/StoreCategoryPage/BrowseRelatedCategory/styled";
import { HeadingSeoSection, SeoContent, Title } from './styled';

export default function HeadingSEO(props) {
  const {
    title,
    description,
    maternity,
    desktopCharLimit,
    desktopClamp,
    fontSize,
    reviewStyle,
    reviews,
    mobileCharLimit,
    author,
    showNewReviewView,
  } = props;
  const [show, setShowMore] = useState('Read More');
  const readMoreRef = useRef();

  const readMoreHandler = () => {
    const list = readMoreRef.current?.classList;
    list.toggle('fullContent');
    if (showingFullContent()) {
      setShowMore('Read Less');
    } else {
      setShowMore('Read More');
    }
  };
  const showingFullContent = () => {
    return readMoreRef.current?.classList?.value?.includes('fullContent');
  };
  const desktopLimit = desktopCharLimit || 565;
  return (
    <HeadingSeoSection
      length={description?.length}
      mobileCharLimit={mobileCharLimit}
      desktopLimit={desktopLimit}
      reviewStyle={reviews}
      author={author}
    >
      {title && (
        <Title maternity={maternity} showNewReviewView={showNewReviewView}>
          {title}
        </Title>
      )}
      {description && (
        <SeoContent
          ref={readMoreRef}
          length={description?.length}
          maternity={maternity}
          desktopLimit={desktopLimit}
          desktopClamp={desktopClamp || 3}
          fontSize={fontSize || 'clamp(13px, 2vw, 16px)'}
          style={reviewStyle || {}}
          reviewStyle={reviews}
          mobileCharLimit={mobileCharLimit}
          author={author}
          showNewReviewView={showNewReviewView}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
      {/* {description.length >= 150 && ( */}
      {description && (
        <span className="readMore" onClick={readMoreHandler}>
          {show}
        </span>
      )}
      {/* )} */}
    </HeadingSeoSection>
  );
}
